import React, { Component } from "react";
import { connect } from "react-redux";
import ProductHeader from "../ProductDetails/ProductHeader";
import { CircularProgress, TextField, Button } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import PersonOutlined from "@material-ui/icons/PersonOutlined";
import LockOutlined from "@material-ui/icons/LockOutlined";
import instance from "../../store/actions/instance";
import { setUser } from "../../store/actions/auth";
import { Redirect } from "react-router";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import { isValidPhoneNumber } from "react-phone-number-input";
import MuiPhoneNumber from "material-ui-phone-number";
import MyStepper from "../CheckoutProcess/MyStepper";

const isVirginPhoneNumber = (phone) => {
  // For Virgin Mobile Kuwait. Numbers are 8 digits long and start with 41
  if (!phone) return false;
  if (
    phone.startsWith("+965") &&
    phone.split("+965")[1].startsWith("41") &&
    phone.split("+965")[1].length === 8
  )
    return true;
  return false;
};

class index extends Component {
  state = {
    phone: this.props.history.location?.state?.phone || "",
    code: "",
    errors: {},
    errorText: "",
    smsSent: false,
    takeNewPassword: false,
    password: "",
    showPassword: false,
    phoneFieldKey: Math.random() * 99999,
    countryDialCode: "",
  };

  submit = async () => {
    const { phone, password, settings } = this.state;
    let errors = { phone: false };
    const phoneCodes = {
      KWD: "+965",
      SAR: "+966",
      OMR: "+968",
      QAR: "+974",
      BHD: "+973",
      AED: "+971",
    };

    if (!this.state.smsSent) {
      if (
        !isValidPhoneNumber(this.state.phone) &&
        !isVirginPhoneNumber(this.state.phone)
      ) {
        errors.phone = true;
        this.setState({ errors: errors });
        return;
      }
    } else if (!this.state.code || this.state.code.length !== 6) {
      errors.code = this.t("Invalid verification code");
      this.setState({ errors: errors });
      return;
    } else if (this.state.takeNewPassword) {
      if (!password.trim() || password.trim().length < 8) {
        if (!password.trim()) errors.password = true;
        if (password.trim() && password.trim().length < 8)
          errors.password = this.t("Minimum length is 8 characters");

        this.setState({ errors: errors });
        return;
      }
    }

    this.setState({ loading: true, errorText: "" });
    try {
      const res = await instance.post("/forgot-password-phone/", this.state);
      if (!res.data.success) {
        if (res.data.message)
          this.setState({ errorText: this.t(res.data.message) });
      } else {
        if (!this.state.smsSent)
          this.setState({ smsSent: true, errorText: "" });
        else if (this.state.takeNewPassword)
          this.props.setUser(res.data.token, this.props.history);
        else this.setState({ takeNewPassword: true, errorText: "" });
      }
    } catch (e) {
      console.error(e);
    }
    this.setState({ loading: false });
  };
  t = (text) => {
    const { language } = this.props;
    if (language === "english") return text;

    const trans = {
      Phone: "رقم الهاتف",
      "Log in": "تسجيل الدخول",
      "Invalid phone number": "رقم هاتف غير صحيح",
      "Please enter your phone number": "الرجاء ادخال رقم الهاتف",
      "Invalid verification code": "رمز تحقق خاطئ",
      "Your password was reset successfully!": "تم تغيير كلمة المرور بنجاح!",
      "Please enter your new password": "الرجاء ادخال كلمة المرور الجديدة",
      "A sms was sent to": "تم ارسال رسالة نصية الى",
      "with a 6 digit verification code. Please enter it below":
        "مع رمز تحقق مكون من 6 رموز. قم بإدخاله ادناه",
      "Verification code": "رمز التحقق",
      "Send OTP": "ارسال رمز تحقق",
      Submit: "المتابعة",
      Password: "كلمة المرور",
      "Confirm password": "تأكيد كلمة المرور",
      "Minimum length is 8 characters": "الحد الأدنى 8 احرف",
      "The two passwords don't match": "لا يوجد تطابق بكلمتي المرور",
    };
    return trans[text] || text;
  };

  handleChange = (e, eventPhone) => {
    const { settings } = this.props;

    if (eventPhone) {
      this.setState({ countryDialCode: eventPhone.dialCode });
    }
    if (typeof e == "string") {
      if (e.startsWith("+" + eventPhone.dialCode)) {
        this.setState({ phone: e });
      } else {
        this.setState({ phoneFieldKey: Math.random() * 999999 });
      }
      if (e.length !== this.state.phone.length && this.state.errors?.phone)
        this.setState({ errors: { ...this.state.errors, phone: false } });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  getSelectedStep = () => {
    const { language } = this.props;
    if (!this.state.smsSent) return language === "english" ? 0 : 2;
    if (this.state.smsSent && !this.state.takeNewPassword) return 1;
    if (this.state.takeNewPassword) return language === "english" ? 2 : 0;
  };
  render() {
    const {
      language,
      auth,
      cart,
      cart_items,
      promo_items,
      customTexts,
      settings,
      countries,
      address,
      store,
    } = this.props;
    const totalCartLength = cart_items.length + promo_items.length;
    if (this.props.auth.user) return <Redirect to="/" />;

    const inputLabelStyle = {
      transformOrigin: language == "english" ? "top left" : "top right",
      right: language == "arabic" ? 0 : "unset",
      left: language == "english" ? 0 : "unset",
    };
    const countryObj = countries?.find((c) => c?.id === address?.country);

    return (
      <div
        className="text-center"
        style={{ backgroundColor: "white", minHeight: "100vh" }}
      >
        <div className="free-space-70-white"></div>
        <ProductHeader onBack={() => this.props.history.goBack()} />

        <MyStepper numberOfSteps={3} selected={this.getSelectedStep()} />
        <div>
          <p
            style={{ fontWeight: "bold", fontSize: 20, marginTop: 15 }}
            className="text-center"
          >
            {this.t("Send OTP")}
          </p>

          <div style={{ padding: "0px 15px" }}>
            {!this.state.smsSent && (
              <>
                <p>{this.t("Please enter your phone number")}</p>

                <MuiPhoneNumber
                  defaultCountry={
                    countryObj?.dial_code || store.default_dial_code || "kw"
                  }
                  onlyCountries={
                    settings.show_all_country_codes
                      ? []
                      : [
                          "kw",
                          "sa",
                          "qa",
                          "om",
                          "ae",
                          "bh",
                          "sy",
                          "lb",
                          "jo",
                          "eg",
                          "us",
                          "uk",
                          "cn",
                        ]
                  }
                  excludeCountries={["il"]}
                  countryCodeEditable={false}
                  disableAreaCodes={true}
                  error={this.state.errors.phone}
                  label={language == "english" ? "Phone *" : "رقم الهاتف *"}
                  className=""
                  color={"#0099cc"}
                  autoComplete="tel"
                  onChange={this.handleChange}
                  key={this.state.phoneFieldKey}
                  value={this.state.phone}
                  fullWidth
                  helperText={
                    this.state.phoneError
                      ? language == "english"
                        ? "Please enter your phone number"
                        : "الرجاء ادخال رقم الهاتف"
                      : ""
                  }
                  FormHelperTextProps={{
                    style: {
                      textAlign: language == "arabic" && "right",
                      marginRight: language == "arabic" && 5,
                    },
                  }}
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language == "english" ? "ltr" : "rtl",
                  }}
                />
                {/* <TextField
                  fullWidth
                  label={this.t("Phone")}
                  required
                  value={this.state.phone.toLowerCase()}
                  //   InputProps={{
                  //     startAdornment: (
                  //       <InputAdornment position="start">
                  //         <PersonOutlined />
                  //       </InputAdornment>
                  //     ),
                  //   }}
                  onChange={(e) =>
                    this.setState({
                      phone: e.target.value,
                      errors: { ...this.state.errors, phone: false },
                      errorText: "",
                    })
                  }
                  error={!!this.state.errors.phone}
                  helperText={
                    typeof this.state.errors.phone === "string"
                      ? this.state.errors.phone
                      : undefined
                  }
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  InputProps={{
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  FormHelperTextProps={{
                    style: {
                      textAlign: language == "arabic" && "right",
                      marginRight: language == "arabic" && 5,
                    },
                  }}
                /> */}
              </>
            )}

            {this.state.smsSent && !this.state.takeNewPassword && (
              <>
                <p style={{ direction: language === "arabic" ? "rtl" : "ltr" }}>
                  {this.t("A SMS was sent to")}{" "}
                  <span style={{ fontWeight: "bold" }}>{this.state.phone}</span>{" "}
                  {this.t(
                    "with a 6 digit verification code. Please enter it below"
                  )}
                </p>{" "}
                <TextField
                  fullWidth
                  label={this.t("Verification code")}
                  required
                  onChange={(e) =>
                    this.setState({
                      code: e.target.value,
                      errors: { ...this.state.errors, code: false },
                      errorText: "",
                    })
                  }
                  error={!!this.state.errors.code}
                  helperText={
                    typeof this.state.errors.code === "string"
                      ? this.state.errors.code
                      : undefined
                  }
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  InputProps={{
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  FormHelperTextProps={{
                    style: {
                      textAlign: language == "arabic" && "right",
                      marginRight: language == "arabic" && 5,
                    },
                  }}
                />
              </>
            )}

            {this.state.takeNewPassword && (
              <>
                <p>{this.t("Please enter your new password")}</p>{" "}
                <TextField
                  fullWidth
                  label={this.t("Password")}
                  className={"mb-4"}
                  required
                  type={this.state.showPassword ? "text" : "password"}
                  onChange={(e) =>
                    this.setState({
                      password: e.target.value,
                      errors: { ...this.state.errors, password: false },
                      errorText: "",
                    })
                  }
                  error={!!this.state.errors.password}
                  helperText={
                    typeof this.state.errors.password === "string"
                      ? this.state.errors.password
                      : undefined
                  }
                  InputLabelProps={{
                    style: inputLabelStyle,
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  InputProps={{
                    dir: language === "english" ? "ltr" : "rtl",
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            this.setState({
                              showPassword: !this.state.showPassword,
                            })
                          }
                          edge="end"
                        >
                          {this.state.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  FormHelperTextProps={{
                    style: {
                      textAlign: language == "arabic" && "right",
                      marginRight: language == "arabic" && 5,
                    },
                  }}
                />
              </>
            )}

            <div>
              {!!this.state.errorText && (
                <p
                  style={{ color: "red", fontWeight: "bold", marginTop: 15 }}
                  className="text-center mb-0"
                >
                  {this.state.errorText}
                </p>
              )}
              <Button
                variant="contained"
                className="my-4"
                style={{
                  backgroundColor: "#0099cc",
                  color: "white",
                  width: 250,
                  height: 50,
                }}
                size="large"
                disableElevation
                onClick={() => this.submit()}
              >
                {!this.state.loading ? (
                  <span className="bold">{this.t("Submit")}</span>
                ) : (
                  <span>
                    <CircularProgress
                      style={{ width: 30, height: 30, color: "white" }}
                    />
                  </span>
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    language: state.store.language,
    auth: state.auth,
    settings: state.store.store.settings,
    cart_items: state.cart.cart,
    promo_items: state.cart.promo_items,
    customTexts: state.store.store.settings.custom_texts,
    branch: state.branch,
    address: state.customers?.address,
    pages: state.staticPages.pages,
    store: state.store.store,
    countries: state.store.store.all_countries || state.store.store.countries,
    store: state.store.store,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (key, history) => dispatch(setUser(key, history)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(index);
